import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { VoicestormLatest } from '../../../models/voicestorm-latest.interface';
import { NewsItemPopupComponent } from '../../news-item-popup/news-item-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { displayModalComponent } from '../../../../widgets/models/utils/general';
import { DatePreferencePipe } from '../../../../../modules/fwcore';
import { ModalOptions } from '../../../../widgets';

@Component({
  selector: 'app-latest-news-item',
  standalone: true,
  imports: [
    NewsItemPopupComponent,
    DatePreferencePipe
  ],
  templateUrl: './latest-news-item.component.html',
  styleUrl: './latest-news-item.component.scss'
})
export class LatestNewsItemComponent {
  @Input() item?: VoicestormLatest;
  @ViewChild('popuptemplate') public popuptemplate?: TemplateRef<any>;

  constructor(private modalService: NgbModal) { }


  itemClick() {
    if (this.item != undefined && this.item.link != undefined) {

      // fire it up in a new window.
      window.open(this.item.link, "_blank");
    }
    else {
      // display it in a popup
      //const componentFactory = this.resolver.resolveComponentFactory(NewsitempopupComponent);
      //let cmpRef = this.viewRef.createComponent(componentFactory);
      //cmpRef.instance.item = this.item;
      const options: ModalOptions = { title: this.item?.title, showSave: false, showCancel: false, showCross: true, scrollable: false };
      displayModalComponent(this.popuptemplate, 'xl', options, this.modalService, []);

    }

  }
}
